var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-x":"hidden"},attrs:{"id":"app"}},[_c('div',[_c('sup-body')],1),_c('el-backtop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }